import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import * as SimstreamActions from '../../actions';
import * as SimstreamConstants from '../../constants';
import * as D from '../../deps';

import './SimStreamViolation.scss';

export class SimStreamViolation extends React.Component {
  static propTypes = {
    activeDeviceImageId: PropTypes.number.isRequired,
    dialogueHeader: PropTypes.node.isRequired,
    dialoguePrompt: PropTypes.node.isRequired,
    letMeListen: PropTypes.func.isRequired,
    letThemListen: PropTypes.func.isRequired,
    shouldStartStation: PropTypes.bool,
    escKeyPressed: PropTypes.bool,
  };

  static defaultProps = {
    activeDeviceImageId: SimstreamConstants.StreamViolationDefaults.GENERIC_DEVICE_IMAGE_ID,
    dialogueHeader: <FormattedMessage {...SimstreamConstants.Messages.simStreamModalTitle} />,
    dialoguePrompt: <FormattedMessage {...SimstreamConstants.Messages.simStreamModalSubTitle} />,
  };

  componentWillReceiveProps(newProps) {
    if (newProps.escKeyPressed && this.props.escKeyPressed !== newProps.escKeyPressed) {
      this.onAcceptClick();
    }
  }

  onAcceptClick = () => {
    this.props.letMeListen(this.props.shouldStartStation);
  };

  onRejectClick = () => {
    this.props.letThemListen();
  };

  getActiveDeviceImage = activeDeviceImageId => {
    switch (activeDeviceImageId) {
      case SimstreamConstants.StreamViolationDefaults.GENERIC_DEVICE_IMAGE_ID:
        return D.GenericIcon;
      case SimstreamConstants.StreamViolationDefaults.PHONE_DEVICE_IMAGE_ID:
        return D.MobileIcon;
      case SimstreamConstants.StreamViolationDefaults.TABLET_DEVICE_IMAGE_ID:
        return D.TabletIcon;
      case SimstreamConstants.StreamViolationDefaults.PC_DEVICE_IMAGE_ID:
        return D.ComputerIcon;
      case SimstreamConstants.StreamViolationDefaults.TV_DEVICE_IMAGE_ID:
        return D.TvIcon;
      default:
        return D.GenericIcon;
    }
  };

  render() {
    return (
      <div className='SimStreamViolation__body'>
        <div className='SimStreamViolation__activeDeviceImage'>
          <D.Icon
            className='icon-device'
            qaTag={D.Constants.QATags.PUMI}
            glyph={this.getActiveDeviceImage(this.props.activeDeviceImageId)}
          />
        </div>
        <div className='SimStreamViolation__content'>
          <D.ModalTitle qaTag={D.Constants.QATags.PUTT}>{this.props.dialogueHeader}</D.ModalTitle>
          <D.ModalSubTitle qaTag={D.Constants.QATags.PUMT}>
            {this.props.dialoguePrompt}{' '}
          </D.ModalSubTitle>
          <div className='SimStreamViolation__buttons'>
            <div className='SimStreamViolation__bottomText'>
              {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
              <div
                className='SimStreamViolation__rejectLink'
                data-qa={D.Constants.QATags.PULTLB}
                onClick={this.onRejectClick}
              >
                <FormattedMessage {...SimstreamConstants.Messages.simStreamModalRejectButtonText} />
              </div>
            </div>
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
            <div
              className='SimStreamViolation__acceptLink'
              data-qa={D.Constants.QATags.PULMLB}
              onClick={this.onAcceptClick}
            >
              <FormattedMessage {...SimstreamConstants.Messages.simStreamModalAcceptButtonText} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, {
  letMeListen: SimstreamActions.letMeListen,
  letThemListen: SimstreamActions.letThemListen,
})(SimStreamViolation);
